// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"67":"supplier","187":"search","275":"article","884":"admin"}[chunkId] + "-legacy." + {"67":"bd14696d","187":"0bfa2212","275":"b4d9df0b","884":"b69fe35d"}[chunkId] + ".js";
};